/**
 * useSubtaskHandlers — UI event handlers for subtask interactions.
 */
import { GoalOperations } from "../goal-state/useGoalEventHandlers";

export const useSubtaskHandlers = (operations: GoalOperations) => {
  const handleAddSubtask = (goalTitle: string, todoId: string, subtaskText: string) => {
    return operations.addSubtask({
      goalTitle,
      todoId,
      subtaskText
    });
  };

  const handleDeleteSubtask = (goalTitle: string, todoId: string, subtaskId: string) => {
    return operations.deleteSubtask({
      goalTitle,
      todoId,
      subtaskId
    });
  };

  const handleToggleSubtask = (goalTitle: string, todoId: string, subtaskId: string) => {
    return operations.toggleSubtask({
      goalTitle,
      todoId,
      subtaskId
    });
  };

  const handleUpdateSubtask = (goalTitle: string, todoId: string, subtaskId: string, newText: string) => {
    return operations.updateSubtask({
      goalTitle,
      todoId,
      subtaskId,
      newText
    });
  };

  return {
    handleAddSubtask,
    handleDeleteSubtask,
    handleToggleSubtask,
    handleUpdateSubtask
  };
};
